
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

import '../styles/style.css'

export default function NotFound() {

    const { t } = useTranslation();
    return (
        <div className="error-div" >
            <div className="container container-error">
                <img alt="Error" className="error-photo1" src="/assets/images/robot.png"/>

                <img alt="Error" className="error-photo2" src="/assets/images/404-2.png"/>
                <p><span className="span1">Oops...</span> &nbsp; {t("notfound.text")}</p>
                <span className="span2">Oops...</span>
            </div>
            <Link to={"/"}>
                <button className="btn-error btn-click">{t("notfound.button")}</button>
            </Link>
        </div>
    )
}